import React from "react"
import PropTypes from "prop-types"
import {PaymentCurrencyType, WalletEntityType} from "@irati/types"
import appsConfig from "@irati-web/app/src/routeConfig"
import authentication from "@irati/auth"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"

import Flex from "@irati/ui/src/Flex"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import {Body, H3, H5, Label} from "@irati/ui/src/Typography"

import mainTheme from "@irati/ui/src/global/theme"
import tracking from "@irati-tracking/recognition/navigation"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {RouterLink} from "@irati/ui/src/Link"
import RewardsTriggerModal from "../RewardsModal/RewardsTriggerModal"
import {StyledCard, Trigger} from "./styled"

const UserRewardPointsWidget: React.FC = (_, {app}) => {
  const hasFlexiRewards = authentication.apps("wallet.flexiRewards")

  if (!hasFlexiRewards) {
    return null
  }

  return (
    <WalletBallance
      fetchPolicy="network-only"
      variables={{userId: authentication.user().uuid, currency: PaymentCurrencyType.Rp, entityType: WalletEntityType.User}}>
      {({data}) => {
        if (!data?.wallet?.amount) {
          return null
        }
        return (
          <>
            <H3 marginBottom={3} marginTop={4}>
              <FormattedMessage id="platform.reward.userWidget.title" />
            </H3>
            <StyledCard medium flush>
              <Trigger>
                <RewardsTriggerModal />
              </Trigger>
              <RouterLink plain onClick={() => tracking.viewRewardCatalog(app)} to="/" app={appsConfig.FLEXIREWARDS}>
                <Flex direction="column" marginBottom={mainTheme.spacing.two}>
                  <Label small color={mainTheme.colors.greys.grey50}>
                    <FormattedMessage id="platform.reward.userWidget.balanceDescription" />
                  </Label>
                  <Body large>
                    <FormattedCurrency value={data.wallet?.amount} currency={PaymentCurrencyType.Rp} />
                  </Body>
                </Flex>
                <Flex alignItems="center" gap={1}>
                  <H5>
                    <FormattedMessage id="platform.reward.userWidget.primaryCta" />
                  </H5>
                  <Icon icon={IconTypes.chevronRight} />
                </Flex>
              </RouterLink>
            </StyledCard>
          </>
        )
      }}
    </WalletBallance>
  )
}

UserRewardPointsWidget.contextTypes = {
  app: PropTypes.string.isRequired
}

export default UserRewardPointsWidget
